<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>Expenses</h2>
    <div class="">
      <div class="mb-10 expense-prompt-message" *ngIf="editable">
        Please provide any travel or related expenses associated with this
        project.
      </div>
      <div class="mb-10 expense-lock-message" *ngIf="!editable">
        <span class="material-icons">lock</span>
        <span>
          Expenses can no longer be edited once your bid has been submitted or
          the offer has been accepted. Please contact
          <a href="mailto:connect@cretelligent.com">connect&#64;cretelligent.com</a>
          with the Project ID and Service if you wish to add or update your
          expenses.
        </span>
      </div>
      <div class="cost-container">
        <div class="form-label">Travel Expenses</div>
        <div class="input-wrapper">
          <span class="currency-symbol">$</span>
          <input
            class="currency-input"
            type="number"
            value=""
            [(ngModel)]="travelCost"
            [disabled]="!editable"
            [ngStyle]="
              editable
                ? { background: 'white' }
                : { background: 'var(--background-2)' }
            "
          />
        </div>
        <div class="form-label">Other Expenses</div>
        <div class="input-wrapper">
          <span class="currency-symbol">$</span>
          <input
            class="currency-input"
            type="number"
            value=""
            [(ngModel)]="otherCost"
            [disabled]="!editable"
            [ngStyle]="
              editable
                ? { background: 'white' }
                : { background: 'var(--background-2)' }
            "
          />
        </div>
        <div *ngIf="otherCost">
          <div class="form-label">
            Other Expense Details<span style="color: red">*</span>
          </div>
          <textarea
            id="otherCostDescription"
            name="otherCostDescription"
            class="text-area"
            rows="5"
            [(ngModel)]="otherCostDescription"
            [disabled]="!editable"
            [ngStyle]="
              editable
                ? { background: 'white' }
                : { background: 'var(--background-2)' }
            "
          ></textarea>
        </div>
      </div>
    </div>
    <div class="documents-dialog__content__footer">
      <div class="documents-dialog__content__footer__service-type">
        <p class="documents-dialog__content__footer__service-type__label">
          Service Type
        </p>
        <p class="documents-dialog__content__footer__service-type__text">
          {{ siteSubType ? siteType + " - " + siteSubType : siteType }}
        </p>
      </div>
      <div class="documents-dialog__content__footer__service-type">
        <p class="documents-dialog__content__footer__service-type__label">
          Location
        </p>
        <p class="documents-dialog__content__footer__location__text">
          <span *ngIf="address.streetAddress"
            >{{ address.streetAddress }}<br /></span
          >{{ address.cityStateZip }}
        </p>
      </div>
      <div class="btnalign">
        <button
          *ngIf="editable"
          class="documents-dialog__content__footer__submit pull-right"
          (click)="submit()"
          [disabled]="otherCost && !otherCostDescription"
        >
          Save
        </button>
        <button
          [ngClass]="editable ? 'btn-default' : 'defaultbtn'"
          (click)="closeDialog()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
